"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressPill = exports.ProgressPills = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
require("./ProgressPills.pc.css");
const ProgressPills = ({ children }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_d34c00a3', '_a2f598a3', '_pub-a2f598a3', '_pub-3c25d522') }, children));
};
exports.ProgressPills = ProgressPills;
const ProgressPill = ({ active }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_3d42618f', '_a2f598a3', '_pub-a2f598a3', '_pub-3c25d522', {
            '_a2f598a3_active _pub-a2f598a3_active _pub-3c25d522_active active': active,
        }) }));
};
exports.ProgressPill = ProgressPill;
//# sourceMappingURL=ProgressPills.js.map